// src/components/atoms/Tabs/Tabs.tsx
import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as styles from './Tabs.css';

export interface TabItem {
  /** URL 경로와 동일하면 활성화됩니다 (예: "/student/exam") */
  id: string;
  label: string;
  /** 탭 클릭 시 호출 → 주로 navigate() 사용 */
  onClick: () => void;
}

export interface TabsProps {
  /** 현재 URL 경로 (예: location.pathname) */
  activeId: string;
  tabs: TabItem[];
}

export const CapsuleTab: React.FC<TabsProps> = ({ tabs, activeId }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const btnRefs = useRef<Record<string, HTMLButtonElement>>({});

  // activeId가 바뀔 때마다 해당 버튼을 중앙으로 스크롤
  useEffect(() => {
    const btn = btnRefs.current[activeId];
    if (btn && containerRef.current) {
      btn.scrollIntoView({
        behavior: 'smooth',
        block:    'nearest',
        inline:   'center',
      });
    }
  }, [activeId]);

  return (
    <div ref={containerRef} className={styles.capsuleTabList} role="tablist">
      {tabs.map(({ id, label, onClick }) => {
        const isActive = id === activeId;
        return (
          <button
            key={id}
            ref={(el) => {
              if (el) btnRefs.current[id] = el;
            }}
            role="tab"
            tabIndex={isActive ? 0 : -1}
            aria-selected={isActive}
            className={`${styles.capsuleTab} ${ 
              isActive
                ? styles.capsuleTabVariants.active
                : styles.capsuleTabVariants.inactive
            }`}
            onClick={() => onClick()}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};